import { AgGridReactProps } from 'ag-grid-react'

import { CustomAgGrid } from '@fortem-monorepo/react-ag'

import { colDefs } from '@/pages/funds/ic-report/components/primitives/tables/stress-test-gryt-columns'
import { ICReportTablePrimitive } from '@/pages/funds/ic-report/components/primitives/types'
import { beta } from '@/react-query/queries/ic-report/hooks'

export interface StressTestGRYTMinus1TableProps extends ICReportTablePrimitive {}

export const StressTestGRYTMinus1Table: React.FC<StressTestGRYTMinus1TableProps> = ({
  params,
  options,
}) => {
  const query = beta.useOldData(params)
  const data = query.data

  const mergedOptions: AgGridReactProps = {
    suppressFieldDotNotation: true,
    ...options,
  }

  return <CustomAgGrid rowData={data} columnDefs={colDefs} {...mergedOptions} />
}
